// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.file.folder.MoveFolderRequest */
/* istanbul ignore next */
@GandalfModel
export class MoveFolderRequest extends GandalfModelBase {

	@GandalfValidator({ sizeString: { min: 1, max: 50, message: '{jakarta.validation.constraints.Size.message}' } })
	@GandalfProperty({ designType: String })
	afterFolderId!: string | null;

	@GandalfValidator({ notNull: { message: '{jakarta.validation.constraints.NotNull.message}' } })
	@GandalfValidator({ sizeString: { min: 1, max: 50, message: '{jakarta.validation.constraints.Size.message}' } })
	@GandalfProperty({ designType: String, isRequired: true })
	folderId!: string;

	@GandalfValidator({ notNull: { message: '{jakarta.validation.constraints.NotNull.message}' } })
	@GandalfValidator({ sizeString: { min: 1, max: 50, message: '{jakarta.validation.constraints.Size.message}' } })
	@GandalfProperty({ designType: String, isRequired: true })
	parentFolderId!: string;

}
